/**
 * @fileOverview 大函数实现
 */
import { callMaxFunctionWithReturnVal } from "../../../api/function_service"
import { getConfigByInstanceId } from "../../../store/common/action";
import {userStore} from "../../../store";
import {getKeyValue} from "../../../store/common/localStorageManager";
import {parseParam} from "../index";

/**
 * 调用大函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const maxFunc = async (func, customParamsList, customFunctionParams, instanceId) => {
  console.log("callMaxFunctionWithReturnVal", func, customParamsList, customFunctionParams)
  console.log("maxFunc---userStore",userStore.state.token)
  let params = {}
  const paramsSize = _size(_get(func, 'inParams'))
  if (paramsSize > 0){
    params = await parseParam(_get(func, 'inParams')[paramsSize-1], customParamsList, customFunctionParams, instanceId);
  }
  let res = await callMaxFunctionWithReturnVal({
    "uniqueId": func.uniqueId,
    "domainCode": getConfigByInstanceId(instanceId).domainModelCode,
    "inputData": { data: params },
    "token": userStore.state.token || getKeyValue('token')
  });
  return  res?.data?.items ?? res?.data ?? [];
}

